<template>
  <article class="exercise-card" :class="{ 'is-complete': item.completed }">
    <div class="exercise-card__heading">
      <span class="exercise-card__icon" aria-hidden="true">{{ item.completed ? '✓' : icon }}</span>
      <span v-if="item.completed" class="exercise-card__status">Completado</span>
      <span v-else class="exercise-card__status">{{ item.completedCount }} de {{ item.total }}</span>
    </div>
    <h3>{{ item.title }}</h3>
    <p>{{ item.instructions }}</p>
    <div class="exercise-card__progress" aria-hidden="true">
      <span :style="{ width: `${item.progressPercent}%` }"></span>
    </div>
    <div class="exercise-card__actions">
      <button class="exercise-button exercise-button--primary" type="button" @click="$emit('open', item, false)">
        {{ item.completedCount ? 'Continuar' : 'Empezar' }}
      </button>
      <button class="exercise-button exercise-button--quiet" type="button" @click="$emit('open', item, true)">
        Desde el principio
      </button>
    </div>
  </article>
</template>

<script>
const KIND_ICONS = {
  choice: '?',
  trend_line: '⌁',
  breakout: '↗',
  resistance: '—',
  level: '—',
  entry_choice: '◎',
  engulfing_classification: '↕',
  order_ticket: '≡'
};

export default {
  name: 'ExerciseCatalogCard',
  props: { item: { type: Object, required: true } },
  computed: {
    icon() { return KIND_ICONS[this.item.kind] || '•'; }
  }
};
</script>

<style lang="scss" scoped>
.exercise-card {
  display: grid;
  gap: 12px;
  min-width: 0;
  padding: 18px;
  border: 1px solid var(--modern-border);
  border-radius: 18px;
  background: var(--modern-surface);
  box-shadow: 0 8px 24px rgba(15, 23, 42, .05);
}
.exercise-card.is-complete { border-color: color-mix(in srgb, var(--modern-accent) 42%, var(--modern-border)); }
.exercise-card__heading, .exercise-card__actions { display: flex; align-items: center; gap: 10px; }
.exercise-card__icon { display: grid; place-items: center; width: 34px; height: 34px; border-radius: 10px; background: var(--modern-accent-soft); color: var(--modern-accent); font-weight: 800; }
.exercise-card__status { margin-left: auto; color: var(--modern-muted); font-size: 12px; font-weight: 700; }
h3 { margin: 0; color: var(--modern-text); font-size: 17px; }
p { min-height: 40px; margin: 0; color: var(--modern-muted); font-size: 14px; line-height: 1.45; }
.exercise-card__progress { height: 7px; overflow: hidden; border-radius: 999px; background: var(--modern-bg); }
.exercise-card__progress span { display: block; height: 100%; border-radius: inherit; background: var(--modern-accent); }
.exercise-card__actions { align-self: end; flex-wrap: wrap; }
.exercise-button { min-height: 44px; padding: 0 15px; border: 0; border-radius: 11px; font: inherit; font-size: 13px; font-weight: 700; cursor: pointer; }
.exercise-button--primary { background: var(--modern-accent); color: #fff; }
.exercise-button--quiet { background: transparent; color: var(--modern-muted); }
.exercise-button:focus-visible { outline: 3px solid color-mix(in srgb, var(--modern-accent) 35%, transparent); outline-offset: 2px; }
@media (max-width: 420px) { .exercise-card__actions { display: grid; } }
</style>
